import PublicProfile from 'views/profile/publicProfile/PublicProfile.container';

export default PublicProfile;